import React from "react";
import ReportsView from "./ReportsView";

export default function Report() {
    return <ReportsView fetchUrl="/reports" />;
}
